export const DEFAULT_TICK_SIZES: Record<string, string> = {
  'A-USD-PERP': '0.01',
  'AAPL-USD-PERP': '0.01',
  'AAVE-PERP': '0.01',
  'ABBV-USD-PERP': '0.01',
  'ABT-USD-PERP': '0.01',
  'ABTC-USD-PERP': '0.01',
  'ACGL-USD-PERP': '0.01',
  'ACHR-USD-PERP': '0.01',
  'ACN-USD-PERP': '0.01',
  'ADBE-USD-PERP': '0.01',
  'ADI-USD-PERP': '0.01',
  'ADM-USD-PERP': '0.01',
  'AEM-USD-PERP': '0.01',
  'AES-USD-PERP': '0.01',
  'AFL-USD-PERP': '0.01',
  'AI-USD-PERP': '0.01',
  'AIG-USD-PERP': '0.01',
  'AIZ-USD-PERP': '0.01',
  'AKAM-USD-PERP': '0.01',
  'ALAB-USD-PERP': '0.01',
  'ALB-USD-PERP': '0.01',
  'ALH-USD-PERP': '0.01',
  'ALL-USD-PERP': '0.01',
  'ALTS-USD-PERP': '0.01',
  'AMAT-USD-PERP': '0.01',
  'AMD-USD-PERP': '0.01',
  'AMGN-USD-PERP': '0.01',
  'AMKR-USD-PERP': '0.01',
  'AMPX-USD-PERP': '0.01',
  'AMT-USD-PERP': '0.01',
  'AMZN-USD-PERP': '0.01',
  'ANET-USD-PERP': '0.01',
  'AON-USD-PERP': '0.01',
  'AOS-USD-PERP': '0.01',
  'APD-USD-PERP': '0.01',
  'APO-USD-PERP': '0.01',
  'APP-USD-PERP': '0.01',
  'APTV-USD-PERP': '0.01',
  'ARM-USD-PERP': '0.01',
  'ASML-USD-PERP': '0.1',
  'ASST-USD-PERP': '0.01',
  'ASTER-PERP': '1e-05',
  'ASTS-USD-PERP': '0.01',
  'AUD-USD-PERP': '1e-06',
  'AVAX-PERP': '0.0001',
  'AVGO-USD-PERP': '0.01',
  'AXP-USD-PERP': '0.01',
  'BA-USD-PERP': '0.01',
  'BABA-USD-PERP': '0.01',
  'BAC-USD-PERP': '0.01',
  'BBAI-USD-PERP': '0.01',
  'BEN-USD-PERP': '0.01',
  'BETA-USD-PERP': '0.01',
  'BETR-USD-PERP': '0.01',
  'BHP-USD-PERP': '0.01',
  'BIDU-USD-PERP': '0.01',
  'BIIB-USD-PERP': '0.01',
  'BITF-USD-PERP': '0.01',
  'BKSY-USD-PERP': '0.01',
  'BLSH-USD-PERP': '0.01',
  'BMNR-USD-PERP': '0.01',
  'BNB-PERP': '0.001',
  'BNC-USD-PERP': '0.01',
  'BR-USD-PERP': '0.1',
  'BTC-PERP': '1',
  'BTC.D-PERP': '0.001',
  'BXP-USD-PERP': '0.01',
  'BYND-USD-PERP': '0.01',
  'CAD-USD-PERP': '1e-06',
  'CAH-USD-PERP': '0.01',
  'CAT-USD-PERP': '0.01',
  'CB-USD-PERP': '0.01',
  'CBOE-USD-PERP': '0.01',
  'CBRE-USD-PERP': '0.01',
  'CCEP-USD-PERP': '0.01',
  'CCJ-USD-PERP': '0.01',
  'CCL-USD-PERP': '0.01',
  'CHF-USD-PERP': '1e-06',
  'CI-USD-PERP': '0.01',
  'CIFR-USD-PERP': '0.01',
  'CL-USD-PERP': '0.01',
  'CMCSA-USD-PERP': '0.01',
  'CME-USD-PERP': '0.01',
  'CMG-USD-PERP': '0.01',
  'CMS-USD-PERP': '0.01',
  'CNC-USD-PERP': '0.01',
  'CNP-USD-PERP': '0.01',
  'COF-USD-PERP': '0.01',
  'COIN-USD-PERP': '0.01',
  'COO-USD-PERP': '0.01',
  'COR-USD-PERP': '0.01',
  'CORZ-USD-PERP': '0.01',
  'COST-USD-PERP': '0.01',
  'CRCL-USD-PERP': '0.01',
  'CRM-USD-PERP': '0.01',
  'CRML-USD-PERP': '0.01',
  'CROX-USD-PERP': '0.01',
  'CRWD-USD-PERP': '0.01',
  'CRWV-USD-PERP': '0.01',
  'CSCO-USD-PERP': '0.01',
  'CSX-USD-PERP': '0.01',
  'CTAS-USD-PERP': '0.01',
  'CVNA-USD-PERP': '0.01',
  'CVS-USD-PERP': '0.01',
  'CVX-USD-PERP': '0.01',
  'CYPH-USD-PERP': '0.01',
  'DAL-USD-PERP': '0.01',
  'DASH-USD-PERP': '0.01',
  'DDOG-USD-PERP': '0.01',
  'DELL-USD-PERP': '0.01',
  'DFDV-USD-PERP': '0.01',
  'DHR-USD-PERP': '0.01',
  'DIS-USD-PERP': '0.01',
  'DKNG-USD-PERP': '0.01',
  'DLR-USD-PERP': '0.01',
  'DOC-USD-PERP': '0.01',
  'DOGE-PERP': '1e-05',
  'DOV-USD-PERP': '0.01',
  'DOW-USD-PERP': '0.01',
  'DRI-USD-PERP': '0.01',
  'DUOL-USD-PERP': '0.01',
  'DVN-USD-PERP': '0.01',
  'EA-USD-PERP': '0.01',
  'EG-USD-PERP': '0.1',
  'ENA-PERP': '1e-05',
  'EOG-USD-PERP': '0.01',
  'EOSE-USD-PERP': '0.01',
  'EQIX-USD-PERP': '0.01',
  'EQT-USD-PERP': '0.01',
  'ERIE-USD-PERP': '0.01',
  'ES-USD-PERP': '0.01',
  'ETH-PERP': '0.01',
  'ETN-USD-PERP': '0.01',
  'EUR-USD-PERP': '1e-06',
  'EXPD-USD-PERP': '0.01',
  'FARTCOIN-PERP': '1e-05',
  'FCEL-USD-PERP': '0.01',
  'FDS-USD-PERP': '0.01',
  'FE-USD-PERP': '0.01',
  'FICO-USD-PERP': '0.1',
  'FIGR-USD-PERP': '0.01',
  'FLUT-USD-PERP': '0.01',
  'FMC-USD-PERP': '0.01',
  'FRT-USD-PERP': '0.01',
  'FSLR-USD-PERP': '0.01',
  'FTNT-USD-PERP': '0.01',
  'FTV-USD-PERP': '0.01',
  'FUTU-USD-PERP': '0.01',
  'GBP-USD-PERP': '1e-06',
  'GC-PERP': '0.1',
  'GDDY-USD-PERP': '0.01',
  'GDX-USD-PERP': '0.01',
  'GEHC-USD-PERP': '0.01',
  'GEMI-USD-PERP': '0.01',
  'GEN-USD-PERP': '0.01',
  'GEV-USD-PERP': '0.01',
  'GFS-USD-PERP': '0.01',
  'GILD-USD-PERP': '0.01',
  'GLD-USD-PERP': '0.01',
  'GLXY-USD-PERP': '0.01',
  'GM-USD-PERP': '0.01',
  'GME-USD-PERP': '0.01',
  'GNRC-USD-PERP': '0.01',
  'GOOGL-USD-PERP': '0.01',
  'GPC-USD-PERP': '0.01',
  'GPN-USD-PERP': '0.01',
  'GRASS-PERP': '1e-05',
  'GRMN-USD-PERP': '0.01',
  'GRND-USD-PERP': '0.01',
  'GS-USD-PERP': '0.01',
  'GWAV-USD-PERP': '0.01',
  'GWW-USD-PERP': '0.01',
  'HAL-USD-PERP': '0.01',
  'HD-USD-PERP': '0.01',
  'HG-PERP': '0.0005',
  'HIG-USD-PERP': '0.01',
  'HIMS-USD-PERP': '0.01',
  'HLT-USD-PERP': '0.01',
  'HON-USD-PERP': '0.01',
  'HOOD-USD-PERP': '0.01',
  'HPE-USD-PERP': '0.01',
  'HPQ-USD-PERP': '0.01',
  'HSDT-USD-PERP': '0.01',
  'HSY-USD-PERP': '0.01',
  'HWM-USD-PERP': '0.01',
  'HYPD-USD-PERP': '0.01',
  'HYPE-PERP': '0.001',
  'IBKR-USD-PERP': '0.01',
  'IBM-USD-PERP': '0.01',
  'ICE-USD-PERP': '0.01',
  'IDXX-USD-PERP': '0.01',
  'INTC-USD-PERP': '0.01',
  'INTU-USD-PERP': '0.01',
  'INVH-USD-PERP': '0.01',
  'IONQ-USD-PERP': '0.01',
  'IQV-USD-PERP': '0.01',
  'IR-USD-PERP': '0.01',
  'IREN-USD-PERP': '0.01',
  'ISRG-USD-PERP': '0.01',
  'IWM-USD-PERP': '0.01',
  'JD-USD-PERP': '0.01',
  'JKHY-USD-PERP': '0.01',
  'JNJ-USD-PERP': '0.01',
  'JPM-USD-PERP': '0.01',
  'JPY-USD-PERP': '1e-06',
  'JUP-PERP': '0.0001',
  'KDP-USD-PERP': '0.01',
  'KEY-USD-PERP': '0.01',
  'KEYS-USD-PERP': '0.01',
  'KHC-USD-PERP': '0.01',
  'KIM-USD-PERP': '0.01',
  'KLAC-USD-PERP': '0.1',
  'KMB-USD-PERP': '0.01',
  'KMI-USD-PERP': '0.01',
  'KMX-USD-PERP': '0.01',
  'KO-USD-PERP': '0.01',
  'KVUE-USD-PERP': '0.01',
  'LEN-USD-PERP': '0.01',
  'LH-USD-PERP': '0.01',
  'LHX-USD-PERP': '0.01',
  'LIN-USD-PERP': '0.01',
  'LIT-USD-PERP': '0.01',
  'LKQ-USD-PERP': '0.01',
  'LLY-USD-PERP': '0.01',
  'LMT-USD-PERP': '0.01',
  'LOW-USD-PERP': '0.01',
  'LRCX-USD-PERP': '0.01',
  'LULU-USD-PERP': '0.01',
  'LVS-USD-PERP': '0.01',
  'MA-USD-PERP': '0.01',
  'MARA-USD-PERP': '0.01',
  'MCD-USD-PERP': '0.01',
  'MCO-USD-PERP': '0.01',
  'MDB-USD-PERP': '0.01',
  'MDLN-USD-PERP': '0.01',
  'MDLZ-USD-PERP': '0.01',
  'MET-USD-PERP': '0.01',
  'META-USD-PERP': '0.01',
  'MGM-USD-PERP': '0.01',
  'MKC-USD-PERP': '0.01',
  'MKTX-USD-PERP': '0.01',
  'MNST-USD-PERP': '0.01',
  'MOS-USD-PERP': '0.01',
  'MP-USD-PERP': '0.01',
  'MRK-USD-PERP': '0.01',
  'MRNA-USD-PERP': '0.01',
  'MRVL-USD-PERP': '0.01',
  'MSFT-USD-PERP': '0.01',
  'MSI-USD-PERP': '0.01',
  'MSTR-USD-PERP': '0.01',
  'MTCH-USD-PERP': '0.01',
  'MU-USD-PERP': '0.01',
  'MVST-USD-PERP': '0.01',
  'NAK-USD-PERP': '0.01',
  'NAKA-USD-PERP': '0.01',
  'NAVN-USD-PERP': '0.01',
  'NBIS-USD-PERP': '0.01',
  'NCLH-USD-PERP': '0.01',
  'NDX-USD-PERP': '0.25',
  'NEAR-PERP': '0.0001',
  'NEE-USD-PERP': '0.01',
  'NEM-USD-PERP': '0.01',
  'NET-USD-PERP': '0.01',
  'NFLX-USD-PERP': '0.01',
  'NI-USD-PERP': '0.01',
  'NIO-USD-PERP': '0.01',
  'NKE-USD-PERP': '0.01',
  'NOK-USD-PERP': '1e-06',
  'NOW-USD-PERP': '0.01',
  'NRG-USD-PERP': '0.01',
  'NTAP-USD-PERP': '0.01',
  'NTRS-USD-PERP': '0.01',
  'NVDA-USD-PERP': '0.01',
  'NVO-USD-PERP': '0.01',
  'NVR-USD-PERP': '0.1',
  'NXPI-USD-PERP': '0.01',
  'NZD-USD-PERP': '1e-06',
  'O-USD-PERP': '0.01',
  'ODFL-USD-PERP': '0.01',
  'OKE-USD-PERP': '0.01',
  'OKLO-USD-PERP': '0.01',
  'OMC-USD-PERP': '0.01',
  'ON-USD-PERP': '0.01',
  'ONDO-PERP': '1e-05',
  'ONDS-USD-PERP': '0.01',
  'OPEN-USD-PERP': '0.01',
  'ORCL-USD-PERP': '0.01',
  'ORLY-USD-PERP': '0.01',
  'OSCR-USD-PERP': '0.01',
  'OTHERS.D-PERP': '0.0001',
  'OTIS-USD-PERP': '0.01',
  'OXY-USD-PERP': '0.01',
  'PANW-USD-PERP': '0.01',
  'PATH-USD-PERP': '0.01',
  'PAXG-PERP': '0.1',
  'PAYC-USD-PERP': '0.01',
  'PAYX-USD-PERP': '0.01',
  'PCAR-USD-PERP': '0.01',
  'PDD-USD-PERP': '0.01',
  'PEG-USD-PERP': '0.01',
  'PEP-USD-PERP': '0.01',
  'PFE-USD-PERP': '0.01',
  'PG-USD-PERP': '0.01',
  'PGR-USD-PERP': '0.01',
  'PH-USD-PERP': '0.01',
  'PLD-USD-PERP': '0.01',
  'PLTR-USD-PERP': '0.01',
  'PM-USD-PERP': '0.01',
  'POET-USD-PERP': '0.01',
  'PRU-USD-PERP': '0.01',
  'PSA-USD-PERP': '0.01',
  'PSX-USD-PERP': '0.01',
  'PTRN-USD-PERP': '0.01',
  'PXED-USD-PERP': '0.01',
  'PYPL-USD-PERP': '0.01',
  'PZZA-USD-PERP': '0.01',
  'QBTS-USD-PERP': '0.01',
  'QCOM-USD-PERP': '0.01',
  'QQQ-USD-PERP': '0.01',
  'QS-USD-PERP': '0.01',
  'QUBT-USD-PERP': '0.01',
  'QURE-USD-PERP': '0.01',
  'RBLX-USD-PERP': '0.01',
  'RCL-USD-PERP': '0.01',
  'RDDT-USD-PERP': '0.01',
  'REG-USD-PERP': '0.01',
  'REMX-USD-PERP': '0.01',
  'RGTI-USD-PERP': '0.01',
  'RIOT-USD-PERP': '0.01',
  'RIVN-USD-PERP': '0.01',
  'RKLB-USD-PERP': '0.01',
  'RL-USD-PERP': '0.01',
  'ROP-USD-PERP': '0.01',
  'RR-USD-PERP': '0.01',
  'RSG-USD-PERP': '0.1',
  'RTX-USD-PERP': '0.01',
  'RTY-USD-PERP': '0.1',
  'SBAC-USD-PERP': '0.01',
  'SBET-USD-PERP': '0.01',
  'SBUX-USD-PERP': '0.01',
  'SCCO-USD-PERP': '0.01',
  'SCHW-USD-PERP': '0.01',
  'SEK-USD-PERP': '1e-06',
  'SHOP-USD-PERP': '0.01',
  'SHW-USD-PERP': '0.01',
  'SI-PERP': '0.005',
  'SIL-USD-PERP': '0.01',
  'SJM-USD-PERP': '0.01',
  'SLB-USD-PERP': '0.01',
  'SLV-USD-PERP': '0.01',
  'SMCI-USD-PERP': '0.01',
  'SMR-USD-PERP': '0.01',
  'SNA-USD-PERP': '0.01',
  'SNAP-USD-PERP': '0.01',
  'SNDK-USD-PERP': '0.1',
  'SNPS-USD-PERP': '0.1',
  'SO-USD-PERP': '0.01',
  'SOFI-USD-PERP': '0.01',
  'SOL-PERP': '0.001',
  'SOLV-USD-PERP': '0.01',
  'SOUN-USD-PERP': '0.01',
  'SPG-USD-PERP': '0.01',
  'SPGI-USD-PERP': '0.01',
  'SPOT-USD-PERP': '0.01',
  'SPX-USD-PERP': '0.25',
  'SPY-USD-PERP': '0.01',
  'SRE-USD-PERP': '0.01',
  'STABLE.D-PERP': '0.0001',
  'STEX-USD-PERP': '0.01',
  'STKE-USD-PERP': '0.01',
  'STLD-USD-PERP': '0.01',
  'STRK-USD-PERP': '0.01',
  'STT-USD-PERP': '0.01',
  'STUB-USD-PERP': '0.01',
  'STZ-USD-PERP': '0.01',
  'SUI-PERP': '0.0001',
  'SWK-USD-PERP': '0.01',
  'SWKS-USD-PERP': '0.01',
  'SYY-USD-PERP': '0.01',
  'T-USD-PERP': '0.01',
  'TAO-PERP': '0.01',
  'TCOM-USD-PERP': '0.01',
  'TDG-USD-PERP': '1',
  'TGT-USD-PERP': '0.01',
  'TJX-USD-PERP': '0.01',
  'TMC-USD-PERP': '0.01',
  'TMQ-USD-PERP': '0.01',
  'TON-PERP': '0.0001',
  'TPL-USD-PERP': '0.01',
  'TRGP-USD-PERP': '0.1',
  'TSLA-USD-PERP': '0.01',
  'TSM-USD-PERP': '0.01',
  'TT-USD-PERP': '0.01',
  'TTD-USD-PERP': '0.01',
  'TTWO-USD-PERP': '0.01',
  'TXN-USD-PERP': '0.01',
  'UAL-USD-PERP': '0.01',
  'UBER-USD-PERP': '0.01',
  'UDR-USD-PERP': '0.01',
  'UEC-USD-PERP': '0.01',
  'ULTA-USD-PERP': '0.01',
  'UNH-USD-PERP': '0.01',
  'UNP-USD-PERP': '0.01',
  'UPS-USD-PERP': '0.01',
  'UPXI-USD-PERP': '0.01',
  'URA-USD-PERP': '0.01',
  'USAR-USD-PERP': '0.01',
  'USO-USD-PERP': '0.01',
  'UUU-USD-PERP': '0.01',
  'UUUU-USD-PERP': '0.01',
  'V-USD-PERP': '0.01',
  'VICI-USD-PERP': '0.01',
  'VLO-USD-PERP': '0.01',
  'VLTO-USD-PERP': '0.01',
  'VRTX-USD-PERP': '0.01',
  'VTRS-USD-PERP': '0.01',
  'VZ-USD-PERP': '0.01',
  'WDAY-USD-PERP': '0.01',
  'WDC-USD-PERP': '0.01',
  'WELL-USD-PERP': '0.01',
  'WIF-PERP': '1e-05',
  'WLD-PERP': '0.0001',
  'WM-USD-PERP': '0.01',
  'WMB-USD-PERP': '0.01',
  'WMT-USD-PERP': '0.01',
  'WRB-USD-PERP': '0.01',
  'WULF-USD-PERP': '0.01',
  'WYNN-USD-PERP': '0.01',
  'XOM-USD-PERP': '0.01',
  'XPEV-USD-PERP': '0.01',
  'XRP-PERP': '1e-05',
  'XYL-USD-PERP': '0.01',
  'ZBH-USD-PERP': '0.01',
  'ZETA-USD-PERP': '0.01',
  'ZK-PERP': '1e-06',
  'ZM-USD-PERP': '0.01',
  'ZRO-PERP': '0.0001',
  'kBONK-PERP': '1e-06',
  'kPEPE-PERP': '1e-06',
};
